/**
 * Created by Andrey Popov on 08.04.2020
 */

const ShopProductSource = {
    listProducts: function (tab) {
        let products = ShopProductSource.ITEMS[tab] || [];

        const coinPayerProducts = ShopProductSource.ITEMS.CoinsPayer;

        const payerClass = cleverapps.paymentsHistory.classify();
        if (tab === ShopWindow.TABS.HARD_CURRENCY && payerClass > cleverapps.PaymentsHistory.BRACKET_WEAK) {
            products = coinPayerProducts;

            if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.newHardShop2) === "A") {
                products = products.filter((id) => id !== "gold500");
            }
        }

        if (tab === ShopWindow.TABS.HARD_CURRENCY && cleverapps.abExperiments.getGroup(ABExperiments.Tests.newHardShop) === "A") {
            products = ShopProductSource.ITEMS.NewHardShop;
        }

        if (tab === ShopWindow.TABS.HARD_CURRENCY) {
            products = products.filter((id) => {
                const product = connector.payments.getProduct(id) || VirtualProducts[id];

                if (!product) {
                    return false;
                }

                if (product.pack && ["merge", "merge2"].includes(cleverapps.config.type)) {
                    return false;
                }

                return !product.mainSceneOnly || cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain;
            });
        }

        if (tab === ShopWindow.TABS.SOFT_CURRENCY && cleverapps.flags.softCurrencyRealProduct) {
            products = products.map((id) => VirtualProducts[id] && VirtualProducts[id].realProductId || id);
        }

        return products;
    },

    // Eligibility (old TileModel.isEnabled): the product carries its own predicates. isEnabled is
    // optional (absent => shown); inABExperiments is the shared A/B gate. Both are plain functions on
    // the product config (Object.assign'd onto the instance), so no tile source/controller is built.
    isProductEnabled: function (product) {
        return (!product.inABExperiments || product.inABExperiments())
            && (!product.isEnabled || product.isEnabled());
    },

    // Whether any product shown in a tab currently wants attention (old tileModel.isAttention), read
    // off each product's own isAttention predicate. Used by the units-shop control button.
    hasAttention: function (tab) {
        return ShopProductSource.listProductsToDisplay(tab).some((product) => product.isAttention && product.isAttention());
    },

    listProductsToDisplay: function (tab) {
        let products;

        if (cleverapps.unitsShop && cleverapps.unitsShop.tabs[tab]) {
            products = cleverapps.unitsShop.tabs[tab].generateProducts().map((data) => new VirtualProduct(data));
        } else {
            products = ShopProductSource.listProducts(tab).map((id) => Product.CreateById(id));
        }

        products = products.filter((product) => {
            if (!product) {
                return false;
            }

            if (product.reward && product.reward.unlimitedLives && cleverapps.unlimitedLives && cleverapps.unlimitedLives.checkBuyed()) {
                return false;
            }

            const limit = product.adsLimit ? product.adsLimit() : undefined;
            return !limit || cleverapps.adsLimits.state(limit) !== AdsLimits.STATE_DISABLED;
        });

        products = products.filter((product) => ShopProductSource.isProductEnabled(product, tab));

        if (tab === ShopWindow.TABS.ENERGY) {
            products = cleverapps.offerManager.getShopProducts(tab).concat(products);
        }

        if (tab === ShopWindow.TABS.HARD_CURRENCY) {
            switch (cleverapps.flags.monetization) {
                case cleverapps.Flags.MONETIZATION_ADS:
                    products = products.slice(0, -2);
                    break;
                case cleverapps.Flags.MONETIZATION_REGULAR:
                    products = cleverapps.offerManager.getShopProducts().concat(products);
                    break;
            }
        }

        if (!cleverapps.fallSale || !cleverapps.fallSale.isAvailable()) {
            ShopProductSource.addBadges(products, tab);
        }

        return products;
    },

    // The tab decides the badges once, the tiles only display product.badge: "save" on the most
    // expensive product of the hard tab, "bestSeller" on the first product the payer class names.
    addBadges: function (products, tab) {
        const regular = cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR;

        if (tab === ShopWindow.TABS.HARD_CURRENCY && regular) {
            const maxPrice = Math.max(0, ...products.map((product) => product.price || 0));
            const save = maxPrice > 0 && products.find((product) => product.price === maxPrice);
            if (save) {
                save.badge = "save";
            }
        }

        if (tab !== ShopWindow.TABS.HARD_CURRENCY || regular) {
            const bestSellers = ShopProductSource.listBestSellers(tab);
            const bestSeller = products.find((product) => bestSellers.includes(product.itemId) && !product.badge);
            if (bestSeller) {
                bestSeller.badge = "bestSeller";
            }
        }
    },

    listBestSellers: function (tab) {
        if (tab === ShopWindow.TABS.HARD_CURRENCY && cleverapps.abExperiments.getGroup(ABExperiments.Tests.newHardShop) === "A") {
            return ShopProductSource.ITEMS.NewHardShopBestSellers;
        }

        return ShopProductSource.ITEMS.bestSellersByPayerClass[cleverapps.paymentsHistory.classify()];
    }
};

ShopProductSource.ITEMS = {
    CoinsPayer: ["hardForVideo", "jamPack", "tastyPack", "honeyPack", "epicPack", "gold500", "gold1800", "gold3800", "gold6000", "gold25000", "subsMonth"],

    bestSellersByPayerClass: [
        ["sweetPack", "gold500"],
        ["jamPack", "gold1800"],
        ["tastyPack", "gold3800"],
        ["honeyPack", "gold6000"],
        ["honeyPack", "gold25000"]
    ]
};

ShopProductSource.ITEMS[ShopWindow.TABS.HARD_CURRENCY] = ["hardForVideo", "sweetPack", "jamPack", "tastyPack", "honeyPack", "gold500", "gold1800", "gold3800", "gold6000", "gold25000", "subsMonth"];
ShopProductSource.ITEMS[ShopWindow.TABS.LIVES] = ["refillLives", "unlimitedLives", "askLives", "livesForVideo", "buyLife"];
ShopProductSource.ITEMS[ShopWindow.TABS.ENERGY] = ["energyLottery", "buyEnergy350", "buyEnergy700", "buyEnergy", "energyForVideo", "energyForVideoShort"];
ShopProductSource.ITEMS[ShopWindow.TABS.SOFT_CURRENCY] = ["softCurrencyVerySmall", "softCurrencySmall", "softCurrencyMedium", "softCurrencyLarge"];

if (["merge"].includes(cleverapps.config.type)) {
    ShopProductSource.ITEMS[ShopWindow.TABS.SOFT_CURRENCY] = ["softCurrencyVerySmall", "softCurrencySmall", "softCurrencyMedium", "softCurrencyLarge"];

    if (["mergecraft", "wondermerge", "fairy"].indexOf(cleverapps.config.name) !== -1) {
        ShopProductSource.ITEMS.CoinsPayer = ["hardForVideo", "gold500", "gold1800", "gold3800",
            "gold6000", "gold25000", "subsMonth", "growthFund"];
        ShopProductSource.ITEMS[ShopWindow.TABS.HARD_CURRENCY] = ["hardForVideo", "gold500",
            "gold1800", "gold3800", "gold6000", "gold25000", "subsMonth", "growthFund"];
    }
}

if (["merge2"].includes(cleverapps.config.type)) {
    const energy = [];

    let price = 20;
    for (let i = 0; i < 10; i++) {
        energy.push(`buyEnergy${price}`);
        price *= 2;
    }
    ShopProductSource.ITEMS[ShopWindow.TABS.ENERGY] = energy.concat(["energyForVideo", "energyForVideoShort"]);
}

ShopProductSource.ITEMS.NewHardShop = ["hardForVideo", "hard2", "hard5", "hard10", "hard20", "hard45", "hard100"];
ShopProductSource.ITEMS.NewHardShopBestSellers = ["hard2"];
